import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Container } from 'semantic-ui-react'
// Local
import { loadVersion } from '../../action/version'
// Styling
import './index.css'

type VersionState = {
  name: string
  projectVersion: string
  envVersion: string
  buildNumber: string
  date: string
  host: string
}

type RootState = {
  version: VersionState
}

type VersionProps = {
  name: string
  projectVersion: string
  envVersion: string
  buildNumber: string
  date: string
  host: string
  loadVersion: () => void
}

function Version(
  props: VersionProps
): JSX.Element {
  const {
    name,
    projectVersion,
    envVersion,
    buildNumber,
    date,
    host,
    loadVersion: loadVersionAction
  } = props

  useEffect(() => {
    loadVersionAction()
  }, [])

  return (
    <Container>
      <table className="versionTable ui celled table">
        <tbody>
          <tr>
            <td>Name</td>
            <td>{ name }</td>
          </tr>
          <tr>
            <td>Project Version</td>
            <td>{ projectVersion }</td>
          </tr>
          <tr>
            <td>Environment Version (use to promote deploys)</td>
            <td>{ envVersion }</td>
          </tr>
          <tr>
            <td>Build Number</td>
            <td>{ buildNumber }</td>
          </tr>
          <tr>
            <td>Date</td>
            <td>{ date }</td>
          </tr>
          <tr>
            <td>Host</td>
            <td>{ host }</td>
          </tr>
        </tbody>
      </table>
    </Container>
  )
}

export default connect(
  (state: RootState) => ({
    name: state.version.name,
    projectVersion: state.version.projectVersion,
    envVersion: state.version.envVersion,
    buildNumber: state.version.buildNumber,
    date: state.version.date,
    host: state.version.host
  }),
  { loadVersion }
)(Version)
